export default function initBikeSync() {
  const btn = document.getElementById('syncBikesBtn')
  if (!btn) return

  let remaining = parseInt(btn.dataset.cooldown, 10) || 0
  let intervalId = null
  let reloadTimeoutId = null
  const url = btn.dataset.url
  const originalText = 'Sync bikes'

  const render = () => {
    if (remaining > 0) {
      btn.disabled = true
      btn.textContent = `${originalText} (${remaining})`
    } else {
      btn.disabled = false
      btn.textContent = originalText
      if (intervalId) { clearInterval(intervalId); intervalId = null }
    }
  }

  const startCountdown = () => {
    if (intervalId) clearInterval(intervalId)
    render()
    intervalId = setInterval(() => { remaining -= 1; render() }, 1000)
  }

  const scheduleReload = () => {
    if (reloadTimeoutId) clearTimeout(reloadTimeoutId)
    reloadTimeoutId = setTimeout(() => window.location.reload(), 5000)
  }

  btn.addEventListener('click', async (e) => {
    e.preventDefault()
    if (remaining > 0) return
    btn.disabled = true
    try {
      const r = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })
      const data = await r.json()
      remaining = data.cooldown || data.remaining || 60
      startCountdown()
      if (r.ok) scheduleReload()
    } catch (err) {
      btn.disabled = false
    }
  })

  if (remaining > 0) startCountdown()
}